<template>
    <div class="container">
        <div class="select-prop">请根据手表型号选择</div>
        <div class="type-item" @click="to900Desc">
            <div class="type-icon">
                <img class="type-img" src="@/assets/common/problem/TA900.png">
            </div>
            <div class="type-name">SYNTIME2</div>
            <div class="type-model">型号: TA906_S、TA900_P、TA900_D</div>
            <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
        </div>
        <div class="type-item" @click="to2000Desc">
            <div class="type-icon">
                <img class="type-img" src="@/assets/common/problem/TA2000.png">
            </div>
            <div class="type-name">SYNTIME3</div>
            <div class="type-model">型号: TA2000</div>
            <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'problemType',
        data() {
            return {

            }
        },
        methods: {
            to900Desc() {
                this.$router.push({
                    name: 'ta900desc'
                })
            },
            to2000Desc() {
                this.$router.push({
                    name: 'ta2000desc'
                })
            }
        }
    }
</script>

<style scoped>

    .select-prop {
        font-size: 14px;
        margin-top: 20px;
        margin-left: 20px;
        color: #a3a3a3;
    }

    .type-item {
        width: 345px;
        height: 70px;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        margin: 20px auto;
        position: relative;
    }

    .type-img {
        width: 50px;
        position: absolute;
        top: 10px;
        left: 15px;
    }

    .type-name {
        font-family: SemiBoldItalic;
        position: absolute;
        left: 70px;
        top: 15px;
        font-size: 15px;
    }

    .type-model {
        position: absolute;
        left: 70px;
        top: 35px;
        font-size: 12px;
        color: #a3a3a3;
    }

    .to-desc-img {
        position: absolute;
        right: 15px;
        top: 28px;
        width: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/views/map/instructions.vue